import React, { useState, useEffect } from 'react';
import { CButton } from "@coreui/react";

const ReOrderTitle = ({ parentId, accordions, setParentAccordions, setModalVisible, setShowTitleFooter }) => {
    const isTopLevel = !parentId;

    const findParentNode = (accordionList, id) =>
        accordionList.flatMap(acc =>
            acc.id === id ? acc : acc.children?.length ? findParentNode(acc.children, id) : []
        ).find(Boolean);


    const parentNode = isTopLevel ? null : findParentNode(accordions.accordions, parentId);


    const [updatedItems, setUpdatedItems] = useState(
        isTopLevel ? [...accordions.accordions] : [...(parentNode?.children || [])]
    );

    useEffect(() => {
        setUpdatedItems(isTopLevel ? [...accordions.accordions] : [...(parentNode?.children || [])]);
    }, [accordions, parentId]);

    const handleDragStart = (event, index) => {
        if (isTopLevel && index === 0) return;
        event.dataTransfer.setData('dragIndex', index);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event, index) => {
        if (isTopLevel && index === 0) return;

        const draggedIndex = parseInt(event.dataTransfer.getData('dragIndex'), 10);
        if (draggedIndex === index) return;

        const newItems = [...updatedItems];
        const [movedItem] = newItems.splice(draggedIndex, 1);
        newItems.splice(index, 0, movedItem);

        setUpdatedItems(newItems);
    };


    const updateNestedAccordions = (accordionList, id, newChildren) => {
        return accordionList.map(acc => {
            if (acc.id === id) {
                return { ...acc, children: newChildren };
            }
            if (acc.children) {
                return { ...acc, children: updateNestedAccordions(acc.children, id, newChildren) };
            }
            return acc;
        });
    };

    const handleSubmit = () => {
        setParentAccordions(prev => {
            if (isTopLevel) {
                return { ...prev, accordions: updatedItems };
            } else {
                return { ...prev, accordions: updateNestedAccordions(prev.accordions, parentId, updatedItems) };
            }
        });

        setModalVisible(false);
        setShowTitleFooter(true)
    };

    return (
        <>
            <div className='d-flex flex-column justify-content-center align-items-center'>
                {updatedItems.map((item, index) => (
                    <div
                        key={item.id}
                        className={`w-75 p-2 py-2 rounded mt-2 pe-reorder-item`}
                        style={{
                            cursor: isTopLevel && index === 0 ? 'default' : 'grab',
                            opacity: isTopLevel && index === 0 ? 0.6 : 1,
                            display: isTopLevel && index === 0 ? 'none' : 'block',
                        }}
                        draggable={!(isTopLevel && index === 0)}
                        onDragStart={(event) => handleDragStart(event, index)}
                        onDragOver={handleDragOver}
                        onDrop={(event) => handleDrop(event, index)}
                    >
                        <h2 style={{ fontSize: '16px', margin: 0 }}>
                            {item.title}
                        </h2>
                    </div>
                ))}
            </div>
            <div className='d-flex justify-content-end align-items-center mt-4 gap-2' style={{ marginRight: '100px' }}>
                <CButton color='secondary' onClick={() => { setModalVisible(false), setShowTitleFooter(true) }} className='px-4 ui-action-btn ui-action-btn--secondary'>Close</CButton>
                <CButton color='primary' onClick={handleSubmit} className='px-4 ui-action-btn ui-action-btn--primary'>Save Order</CButton>
            </div>
        </>
    );
};

export default ReOrderTitle;
